import { Country, countryToLocalesMap, Locale } from '@/i18n/routing'
import { coConfig } from '@/config/co/config'
import { mxConfig } from '@/config/mx/config'
import { crConfig } from '@/config/cr/config'
import { LocaleConfig } from '@/config/types'

export const localeConfigs: Record<Locale, LocaleConfig> = {
  'es-MX': mxConfig,
  'es-CO': coConfig,
  'es-CR': crConfig
}

export function getLocaleConfig(locale: Locale): LocaleConfig {
  return localeConfigs[locale] || localeConfigs['es-MX']
}

export function getLocaleConfigByCountryWithFallback(
  country: Country | null,
  preferredLocale?: Locale
): LocaleConfig | null {
  if (!country) return null

  const availableLocales = countryToLocalesMap[country]

  if (!availableLocales?.length) {
    return localeConfigs['es-MX']
  }

  if (preferredLocale && availableLocales.includes(preferredLocale)) {
    return localeConfigs[preferredLocale]
  }

  return localeConfigs[availableLocales[0]]
}
